import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    url: String
  }

  connect() {
    // Add cursor-pointer class if not already present
    if (!this.element.classList.contains('cursor-pointer')) {
      this.element.classList.add('cursor-pointer')
    }
  }

  navigate(event) {
    // Prevent default only if it's not a link or button
    if (!event.target.closest('a, button')) {
      event.preventDefault()
      window.location.href = this.urlValue
    }
  }

  stopPropagation(event) {
    event.stopPropagation()
  }
} 
